<template>
  <div class="browse-by-component">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-md-offset-3 col-xs-12 text-center">
                <h1><span class="grey-text">Browse All Vehicles</span></h1>
                <div class="line-divide"></div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 text-center">
                <ul class="nav nav-tabs" role="tablist">
                    <li role="presentation" class="active">
                        <a href="#browse-by-price" aria-controls="browse-by-price" role="tab" data-toggle="tab">
                            <h5>Browse by Price</h5>
                            <p>From budget to luxury</p>
                        </a>
                    </li>
                    <li role="presentation">
                        <a href="#browse-by-mileage" aria-controls="browse-by-mileage" role="tab" data-toggle="tab">
                            <h5>Browse by Mileage</h5>
                            <p>Like new or well driven</p>
                        </a>
                    </li>
                    <li role="presentation">
                        <a href="#browse-by-features" aria-controls="browse-by-features" role="tab" data-toggle="tab">
                            <h5>Browse by Features</h5>
                            <p>Luxurious extras</p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane active" role="tabpanel" id="browse-by-price">
                <div class="row">
                    <div class="col-md-3 col-sm-6 col-xs-6" v-for="(title, index) in prices.titles" :key="index">
                        <div class="feature-box">
                            <a href="#">
                                <h4>{{title}}</h4>
                                <img class="img-responsive center-block" :alt="allVehicles[index].modelName" :src="allVehicles[index].sideView">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" role="tabpanel" id="browse-by-mileage">
                <div class="row">
                    <div class="col-5 col-sm-6 col-xs-6" v-for="(title, index) in mileages.titles" :key="index">
                        <div class="feature-box">
                            <a href="#">
                                <h4>{{title}}</h4>
                                <img class="img-responsive center-block" :alt="allVehicles[index].modelName" :src="allVehicles[index].angleView">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" role="tabpanel" id="browse-by-features">
                <div class="row">
                    <div class="col-md-3 col-sm-6 col-xs-6">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Navigation</h4>
                                <img class="img-responsive center-block" alt="Navigation" src="../../static/images/common-icons/navigation-icon.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Bluetooth</h4>
                                <img class="img-responsive center-block" alt="Bluetooth" src="../../static/images/common-icons/bluetooth-icon.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Backup Camera</h4>
                                <img class="img-responsive center-block" alt="Backup Camera" src="../../static/images/common-icons/camera-icon.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Leather Seats</h4>
                                <img class="img-responsive center-block" alt="Leather Seats" src="../../static/images/common-icons/leather-icon.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 col-offset-md-1 col-sm-6 col-xs-6">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Moonroof</h4>
                                <img class="img-responsive center-block" alt="Moonroof" src="../../static/images/common-icons/moon-icon.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Sunroof</h4>
                                <img class="img-responsive center-block" alt="Sunroof" src="../../static/images/common-icons/sun-icon.png">
                            </a>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6 col-offset-sm-3">
                        <div class="feature-box">
                            <a href="#">
                                <h4>Cruise Control</h4>
                                <img class="img-responsive center-block" alt="Cruise Control" src="../../static/images/common-icons/cruise-icon.png">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      prices: {
        titles: ['Used Cars Under 10K', 'Used Cars Under 20K', 'Used Cars Under 30K', 'Used Cars Under 40K']
      },
      mileages: {
        titles: ['Cars Under 10K', 'Cars Under 20K', 'Cars Under 50K', 'Cars Under 70K', 'Cars Under 100K']
      }
    }
  },
  computed: {
    allVehicles () {
      let multiArr = [];
      multiArr.push(this.images.sedans, this.images.suvs, this.images.trucks);
      var flatArr = [].concat.apply([], multiArr);
      return this.shuffle(flatArr);
    },
  },
  methods: {
    shuffle(array) {
        let currentIndex = array.length,  randomIndex;

        while (currentIndex != 0) {

            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        }
        return array;
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.browse-by-component {
    background: #fff;
    padding: 0px 0 50px;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.browse-by-component.word-space {
    padding: 50px 0 30px;
}
.browse-by-component.button-row {
    padding: 50px 0px 0px;
}
.browse-by-component .line-divide {
    height: 3px;
    width: 100px;
    display: block;
    margin: auto;
    background: var(--primary-color);
}
.browse-by-component .grey-text, .browse-by-component a h4, .browse-by-component h5, .browse-by-component a h4:hover {
    color: var(--secondary-dark);
}
.browse-by-component .black-text {
    color: var(--primary-dark);
}
.browse-by-component h1 {
    margin-bottom: 40px;
}
.browse-by-component .container-fluid {
    margin-top: 20px;
}
.browse-by-component .tab-pane .row {
    padding-top: 35px;
    padding-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
}
.browse-by-component a {
    text-decoration: none !important;
}
.browse-by-component .feature-box {
    padding: 15px;
    background: #fff;
    box-shadow: 0 2px 30px 0 rgba(0,0,0,.2);
    height: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
text-align: center;
}
.browse-by-component #browse-by-features .feature-box {
padding-bottom: 35px;
}
.browse-by-component #browse-by-features .feature-box img {
max-height: 120px;
}
.browse-by-component .feature-box:hover {
    transform: scale(1.05);
}
.browse-by-component .nav-tabs {
    text-align: center;
    border: none !important;
}
.browse-by-component .nav-tabs li {
    float: none;
    display: inline-block;
    border: none !important;
    padding: 10px;
    background: #f5f5f5;
    box-shadow: 0 2px 30px 0 rgba(0,0,0,.1);
    margin: auto 15px 10px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
}
.browse-by-component .nav-tabs li.active {
    background: #fff;
}
.browse-by-component .nav-tabs li:hover {
background: #fff;
}
.browse-by-component .nav-tabs li a {
    border: none !important;
color: var(--secondary-dark) !important;
}
.browse-by-component .nav-tabs li a h5 {
font-size: 16px;
font-weight: 500;
}
.browse-by-component .nav-tabs li a:hover {
background: transparent;
}
.browse-by-component .all-btn {
    background: var(--primary-color);
    color: #fff;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 20px 50px;
    margin: 30px auto 70px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
}
.browse-by-component .all-btn:hover {
    opacity: .7;
}
.browse-by-component .col-xs-6 {
    margin-bottom: 30px;
}

@media (min-width: 992px) {
    .browse-by-component .col-5 {
        width: 19.9%;
    }
    .browse-by-component .col-md-3 {
        width: 24.9%;
    }
    .browse-by-component .col-offset-md-1 {
        margin-left: 13%;
    }
    .browse-by-component.word-space {
        font-size: 18px;
    }
}
@media (max-width: 991px) and (min-width: 768px) {
    .browse-by-component .col-offset-sm-3 {
        margin-left: 25%;
    }
}
@media (max-width: 991px) {
    .browse-by-component.word-space {
        font-size: 16px;
    }
.browse-by-component .all-btn {
margin-bottom: 40px;
}
}
</style>
